import * as Types from '../actions/ActionTypes';

const LandingPageReducer = function (state, action) {
    switch (action.type) {
        case Types.UPDATE_LANDING_ACTIVE_TAB: {
            return {
                ...state,
                landingActiveTab: action.payload,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default LandingPageReducer
